/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@mui/material";
import cn from "classnames";

const TextFieldEditor = (props) => {
    const {
        containerClassName,
        currentTextValue,
        editMode,
        fileNameExist,
        handleCancelEdit,
        handleOpenEditor,
        handleSave,
        handleTextValueChange,
        loading,
        maxTextLength,
        newTextValue,
        renameFileNameValid,
        showEditButton,
        // hideDisplay = false,
    } = props;
    
    // const showDisplay = !!hideDisplay
    
    return (
        <div className={cn("text-field-editor-container", containerClassName)}>
            {editMode && (
                <div className="text-field-editor">
                    <input
                        type="text"
                        value={newTextValue}
                        onChange={handleTextValueChange}
                        autoFocus
                        className={`text-field-input ${fileNameExist ? "file-name-exist": ""} ${!renameFileNameValid ? "file-name-invalid": ""}`}
                        disabled={loading}
                        maxLength={maxTextLength}
                    />
                    <button
                        className="cancel-button"
                        onClick={handleCancelEdit}
                        disabled={loading}
                    >
                        <FontAwesomeIcon
                            icon="fa-regular fa-xmark"
                            size="2xl"
                        />
                    </button>
                    <button
                        className="save-button"
                        onClick={handleSave}
                        disabled={loading || fileNameExist}
                    >
                        {loading && (
                            <CircularProgress color="secondary" size="22px"/>
                        )}
                        {!loading && (
                            <FontAwesomeIcon
                                icon="fa-regular fa-check"
                                size="2xl"
                            />
                        )}
                    </button>
                </div>
            )}
            {!editMode && (
                <>
                    {/*{showDisplay &&*/}
                    <span className="text-field-display">{currentTextValue}</span>
                    {/*}*/}
                    {showEditButton &&
                        <button className="edit-button" onClick={handleOpenEditor}>
                            <FontAwesomeIcon
                                icon="fa-regular fa-pen-to-square"
                                color="#0E7490"
                                size="lg"
                            />
                        </button>
                    }
                </>
            )}
        </div>
    );
};

export { TextFieldEditor };
